import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { fetchSystemStatus } from '../../state/api/actions'

const useAPIStatus = () => {
  const dispatch = useDispatch()
// @ts-expect-error - TS18046 - 'state' is of type 'unknown'.
  const apiStatus = useSelector((state) => state.api?.systemStatus) || {}

  useEffect(() => {
    dispatch(fetchSystemStatus())
  }, [])

  return apiStatus
}

export default useAPIStatus
